import React, { PropsWithChildren, useEffect, useRef } from "react";
import { generatePath, useLocation, useNavigate } from "react-router-dom";

import { Flex } from "@chakra-ui/react";

import { PAGE_PATHS } from "config/routes";
import { useFeatureFlags } from "contexts/FeatureFlagsContext/FeatureFlagsContext";
import { useLayout } from "contexts/LayoutContext/LayoutContext";
import { Loader } from "elements";
import { setStatusBarColorByPathname } from "utils/setStatusBarColorByPathname";
import OneTrust from "utils/tracking/consents/OneTrust";

const AppInitializer: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoading: isLoadingFeatureFlags, isError } = useFeatureFlags();
  const navigate = useNavigate();
  const location = useLocation();

  const { displayAddToHomeScreenBanner } = useLayout();

  const isLoading = isLoadingFeatureFlags;

  useEffect(() => {
    setStatusBarColorByPathname(location.pathname, displayAddToHomeScreenBanner);
  }, [location.pathname, displayAddToHomeScreenBanner]);

  useEffect(() => {
    if (isError) {
      navigate(generatePath(PAGE_PATHS.ERROR_PAGE));
    }
  }, [isError]);

  // OneTrust SPA integration
  const oneTrustSpaUrl = useRef<string | null>(location.pathname);
  useEffect(() => {
    if (location.pathname !== oneTrustSpaUrl.current) {
      OneTrust.notifyPageChange();
      oneTrustSpaUrl.current = location.pathname;
    }
  }, [location.pathname]);

  if (isLoading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100%">
        <Loader />
      </Flex>
    );
  }

  return <>{children}</>;
};

export default AppInitializer;
